'use client';

export const textLang: any = {
    us: {
        win_title: 'Shopping Cart',
        win_subtotal: 'SUBTOTAL',
        win_checkout: 'Checkout',
    },
    jp: {
        win_title: 'ショッピングカート',
        win_subtotal: '合計',
        win_checkout: 'ご購入手続きへ',
    },
    ca: {
        win_title: 'Shopping Cart',
        win_subtotal: 'SUBTOTAL',
        win_checkout: 'Checkout',
    },
    eu: {
        win_title: 'Shopping Cart',
        win_subtotal: 'SUBTOTAL',
        win_checkout: 'Checkout',
    },
    za: {
        win_title: 'Shopping Cart',
        win_subtotal: 'SUBTOTAL',
        win_checkout: 'Checkout',
    },
    de: {
        win_title: 'Warenkorb',
        win_subtotal: 'GESAMT',
        win_checkout: 'Zur Kasse',
    },
    au: {
        win_title: 'Shopping Cart',
        win_subtotal: 'SUBTOTAL',
        win_checkout: 'Checkout',
    },
    fr: {
        win_title: 'Panier',
        win_subtotal: 'TOTAUX DES CHARIOTS',
        win_checkout: 'Paiement',
    },
    es: {
        win_title: 'Carrito de compras',
        win_subtotal: 'TOTALES DE CARRO',
        win_checkout: 'Verificar',
    },
    it: {
        win_title: 'Carrello della spesa',
        win_subtotal: 'TOTALI DEL CARRELLO',
        win_checkout: 'Checkout',
    },
    kr: {
        win_title: '장바구니',
        win_subtotal: '합계',
        win_checkout: '결제',
    },
    nl: {
        win_title: 'Winkelwagen',
        win_subtotal: 'SUBTOTAAL',
        win_checkout: 'Uitchecken',
    },
};
